import { render, staticRenderFns } from "./ExternalLinkSelector.vue?vue&type=template&id=392c788c&scoped=true&"
import script from "./ExternalLinkSelector.vue?vue&type=script&lang=ts&"
export * from "./ExternalLinkSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ExternalLinkSelector.vue?vue&type=style&index=0&id=392c788c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392c788c",
  null
  
)

export default component.exports